module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#cinema",
      toString: function () {
        return this.url;
      }
    }